import { STATUS_TYPE } from '../../../enum';

export interface GetPurchasePlan {
  id: string;
}

export interface FindPurchasePlan {
  limit?: number;
  skip?: number;
  search?: string;
}

export interface CreatePatchPurchasePlan {
  id?: string;
  title: string;
  description?: string;
  position: number;
  planPrice: number;
  creditPrice: number;
  leadPrice?: number;
  purchaseType: string;
  subscriptionInterval: string;
  activeState: boolean;
  subscriptionPlanId?: string;
}

export interface PurchasePlans {
  id: string;
  title: string;
  description?: string;
  position: number;
  planPrice: number;
  creditPrice: number;
  leadPrice?: number;
  purchaseType: string;
  subscriptionInterval: number;
  activeState: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: PurchasePlans[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 15,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
